
import { useState } from 'react';

interface AIResponse {
  response: string;
  followUpQuestions: string[];
  confidence: number;
  timestamp: string;
  source?: 'openai' | 'fallback' | 'error_fallback';
}

export const useSimpleAISearch = () => {
  const [aiResponse, setAiResponse] = useState<AIResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loadingMessage, setLoadingMessage] = useState('');

  const searchWithAI = async (query: string) => {
    if (!query.trim()) return;

    setIsLoading(true);
    setError(null);
    setLoadingMessage('Processing your question...');

    try {
      // Create a proper AIResponse object structure
      const mockResponse: AIResponse = {
        response: `Based on your question about "${query}", here's what I can help you with. Our comprehensive business solutions are designed to address exactly these types of challenges. We offer tailored approaches that combine cutting-edge technology with proven business methodologies to deliver measurable results for your organization.`,
        followUpQuestions: [
          'What specific industry requirements do you have?',
          'How large is your current team?',
          'What is your preferred implementation timeline?'
        ],
        confidence: 0.85,
        timestamp: new Date().toISOString(),
        source: 'openai' as const
      };

      // Simulate API delay
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      setAiResponse(mockResponse);
      setLoadingMessage('');
    } catch (error) {
      console.error('AI Search error:', error);
      setError('Unable to process your question at the moment. Please try again.');
      setLoadingMessage('');
    } finally {
      setIsLoading(false);
    }
  };

  const clearResponse = () => {
    setAiResponse(null);
    setError(null);
    setLoadingMessage('');
  };

  return {
    aiResponse,
    isLoading,
    error,
    loadingMessage,
    searchWithAI,
    clearResponse
  };
};
